import { NavLink, useLocation } from "react-router-dom";
import { useMemo, useState } from "react";
import {
  FaTachometerAlt,
  FaPaperPlane,
  FaExchangeAlt,
  FaUniversity,
  FaCreditCard,
  FaChartBar,
  FaDollarSign,
  FaMoneyBillAlt,
  FaTicketAlt,
} from "react-icons/fa";

import dummy from "src/assets/images/dummy.jpg";
import axiosInstance from "src/api/Api";
import { useQuery } from "@tanstack/react-query";

export default function Sidebar() {
  const location = useLocation();

  const { data: profileData } = useQuery({
    queryKey: ["userProfile"],
    queryFn: () => {
      return axiosInstance.get("/require/profile");
    },
  });

  const menuItems = useMemo(
    () => [
      {
        type: "link",
        label: "Dashboard",
        path: "/dashboard",
        icon: FaTachometerAlt,
      },
      {
        type: "link",
        label: "Send Money",
        path: "/send_money",
        icon: FaPaperPlane,
      },
      {
        type: "link",
        label: "Exchange Money",
        path: "/exchange_money",
        icon: FaExchangeAlt,
      },
      {
        type: "link",
        label: "Wire Transfer",
        path: "/wire_transfer",
        icon: FaUniversity,
      },
      {
        type: "group",
        key: "deposit",
        label: "Deposit Request",
        icon: FaCreditCard,
        children: [
          {
            label: "Automatic Deposit",
            path: "/no-access",
          },
          {
            label: "Manual Deposit",
            path: "/no-access",
          },
          {
            label: "Redeem Gift Card",
            path: "/no-access",
          },
        ],
      },
      {
        type: "group",
        key: "payment",
        label: "Payment Request",
        icon: FaCreditCard,
        children: [
          {
            label: "New Request",
            path: "/payment_request",
          },
          {
            label: "All Requests",
            path: "/all_request",
          },
        ],
      },
      {
        type: "link",
        label: "Withdrawal Money",
        path: "/no-access",
        icon: FaCreditCard,
      },
      {
        type: "group",
        key: "loans",
        label: "Loans",
        icon: FaDollarSign,
        children: [
          {
            label: "Apply New Loan",
            path: "/no-access",
          },
          {
            label: "My Loan",
            path: "/no-access",
          },
          {
            label: "Loan Calculator",
            path: "/no-access",
          },
        ],
      },
      {
        type: "group",
        key: "fized-deposit",
        label: "Fixed Deposit",
        icon: FaMoneyBillAlt,
        children: [
          {
            label: "Apply New FRD",
            path: "/no-access",
          },
          {
            label: "FDR History",
            path: "/no-access",
          },
        ],
      },
      {
        type: "group",
        key: "support-tickets",
        label: "Support Tickets",
        icon: FaTicketAlt,
        children: [
          {
            label: "Create New Ticket",
            path: "/no-access",
          },
          {
            label: "Pending Tickets",
            path: "/no-access",
          },
          {
            label: "Active Tickets",
            path: "/no-access",
          },
          {
            label: "Closed Tickets",
            path: "/no-access",
          },
        ],
      },
      {
        type: "link",
        label: "Transactions Report",
        path: "/transactions_report",
        icon: FaChartBar,
      },
    ],
    [],
  );

  const getDefaultOpen = () => {
    const activeGroup = menuItems.find(
      (item) =>
        item.type === "group" &&
        item.children.some((child) => child.path === location.pathname),
    );

    return activeGroup?.key || null;
  };

  const [open, setOpen] = useState(getDefaultOpen);

  const toggle = (key) => {
    setOpen((prev) => (prev === key ? null : key));
  };

  const baseLink =
    "flex items-center px-[25px] py-[10px] text-[15px] text-gray-500 hover:bg-gray-100 transition w-full";

  const activeLink = "text-blue-600 font-medium";
  const activeBg = "bg-blue-50";

  const navIcon = "mr-2 text-[16px] text-current w-[18px] flex justify-center";

  // const profile = localStorage.getItem("userDetails");
  // const profileDetails = profile ? JSON.parse(profile) : {};

  return (
    <aside
      className="
        w-[250px]
        shadow-[0_0_35px_rgba(154,161,171,0.15)]
        flex-shrink-0
        ml-10
        mt-6
      "
    >
      {/* USER SECTION */}
      <div
        className="px-5 pt-8 pb-3 text-center bg-no-repeat bg-cover"
        style={{
          backgroundImage:
            "url(http://cayman.costhub.in/public/backend/images/header-bg.png)",
        }}
      >
        <img
          src={profileData?.data?.data?.profile_path || dummy}
          alt="Avatar"
          className="h-[48px] w-[42px] mx-auto rounded-full object-cover border shadow-sm mb-2"
        />

        <p className="text-sm font-semibold uppercase text-gray-800 leading-tight">
          {profileData?.data?.data?.company_name || "Company Name"}
        </p>

        <p className="text-xs font-semibold uppercase text-gray-600">
          ({profileData?.data?.data?.username || "USER"})
        </p>
      </div>

      {/* MENU */}
      <nav className="flex-1 overflow-y-auto">
        <div className="px-[25px] pt-6 pb-3 text-[12px] font-bold uppercase text-gray-500">
          Navigations
        </div>

        {menuItems.map((item) => {
          if (item.type === "link") {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/dashboard"}
                className={({ isActive }) =>
                  `${baseLink} ${isActive ? `${activeLink} ${activeBg}` : ""}`
                }
              >
                <span className={navIcon}>
                  <Icon />
                </span>
                {item.label}
              </NavLink>
            );
          }

          const Icon = item.icon;

          const isActive = item.children.some(
            (child) => child.path === location.pathname,
          );

          return (
            <div key={item.key}>
              <button
                onClick={() => toggle(item.key)}
                className={`${baseLink} ${
                  isActive ? `${activeLink} ${activeBg}` : ""
                }`}
              >
                <span className={navIcon}>
                  <Icon />
                </span>
                {item.label}
              </button>

              {open === item.key && (
                <div className="pl-[45px]">
                  {item.children.map((child) => (
                    <NavLink
                      key={child.path}
                      to={child.path}
                      className={({ isActive }) =>
                        `block py-2 text-[14px] ${
                          isActive
                            ? "text-blue-600 font-medium"
                            : "text-gray-500"
                        } hover:text-blue-600`
                      }
                    >
                      {child.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
